import React, { useEffect, useState } from 'react'
import { Container, Grid } from '@material-ui/core'
import { ChatbotConfigurationKnowledgeView } from '../../views'
import { ChatbotService } from '../../../services';
import { ModalUtil, SimpleLoading, HeaderHLPure } from '../../pures';
import { useTranslation } from 'react-i18next';
import { useGlobalState } from '../../../GlobalState';

const ChatbotConfigurationKnowledgeAction = (props) => {
    const { setLoading, files, setFiles } = props
    const { t } = useTranslation()
    
    const modalUtil = new ModalUtil()

    const url = process.env.REACT_APP_ETICKET_API
    const chatbotService = new ChatbotService(url)

    const [filesToUpload, setFilesToUpload] = useState([])
    const [fileToDelete, setFileToDelete] = useState(false);
    const { botConfig } = useGlobalState()
    
    const uploadFiles = async (filesToUpload) => {
        try {
            modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))
            const formData = new FormData();
            filesToUpload.forEach((file) => {
                formData.append('knowledgeFiles', file.getRawFile());
            });

            let data = await chatbotService.uploadKnowledgeFiles(formData, botConfig?.id)
            if (filesToUpload.length > 1) {
                if (files.length === 0) {
                    data = data.map(file => ({...file, id: file.id.replace(/'/g, '')}))
                    setFiles(prev => [...prev, ...data])
                } else {
                    setFiles(prev => {
                        let updatedFiles = [...prev]
                        data = data.map(file => ({...file, id: file.id.replace(/'/g, '')}))
                        let objectMap = new Map(data.map(obj => [obj.name, obj]))
                        updatedFiles = updatedFiles.map(file => objectMap.has(file.name) ? objectMap.get(file.name) : file)
                        let newData = data.filter(file => !updatedFiles.find(f => f.name === file.name))
                        updatedFiles = [...updatedFiles, ...newData]
                        return updatedFiles
                    })
                }
            } else {
                if (files.length === 0) {
                    setFiles(prev => [...prev, data])
                } else {
                    setFiles(prev => {
                        let updatedFiles = [...prev]
                        const index = updatedFiles.findIndex(file => file.name === data.name)
                        if (index !== -1) {
                            updatedFiles[index] = data
                        } else {
                            updatedFiles.push(data)
                        }
                        return updatedFiles
                    })
                }
            }
            setFilesToUpload([])

            modalUtil.showModal('success', null, t("modal.pure.title.success"))
        } catch (error) {
            modalUtil.showModal('error', error.message, t("modal.pure.title.error"))
        }
    }

    const deleteFile = async () => {
        try {
            modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))
            const id = fileToDelete.id
            setFileToDelete(null)
            await chatbotService.deleteKnowledgeFile(id, botConfig?.id)
            setFiles(prev => prev.filter(file => file.id !== id))
            modalUtil.showModal('success', null, t("modal.pure.title.success"))
        } catch (error) {
            modalUtil.showModal('error', error.message, t("modal.pure.title.error"))
        }
        setLoading(false)
    }

    return (
        <ChatbotConfigurationKnowledgeView
            files={files}
            uploadFiles={uploadFiles}
            filesToUpload={filesToUpload}
            setFilesToUpload={setFilesToUpload}
            deleteFile={deleteFile}
            fileToDelete={fileToDelete}
            setFileToDelete={setFileToDelete}
        />
    )
}

export default ChatbotConfigurationKnowledgeAction